import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { AsrProxyConsoleProvider } from './providers/AsrProxyConsoleProvider';

export const AsrProxyConsolePage = () => (
  <>
    <Helmet>
      <title>ASR Console - AutoScript Admin</title>
    </Helmet>
    <AsrProxyConsoleProvider>
      <Content />
    </AsrProxyConsoleProvider>
  </>
);
